var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.554 14.002 1.662-1.565.784.738L12 16l-3-2.825.784-.738 1.662 1.565V9h1.108v5.002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2h11.116l5.48 5.48V22H4V2Zm1.277 1.277v17.446h14.042V8.383h-5.106V3.277H5.277Zm10.212.902 2.927 2.927H15.49V4.18Z",
    fill: "currentColor"
  })));
};
export { SvgDownload as ReactComponent };
export default __webpack_public_path__ + "c289df6d22e77133cd8897953a2fbbc8.svg";